import { OrderSummaryCollapsed } from 'components/orderSummary/components/collapsed/collapsed';
import { OrderNotes } from 'components/orderSummary/components/orderNotes/orderNotes';
import { OrderSummaryToggle } from 'components/orderSummary/components/toggle/toggle';
import { GiftCardChips } from 'components/orderSummary/components/giftCardChips/giftCardChips';
import { PromoCodeForm } from 'components/orderSummary/components/promoCodeForm/promoCodeForm';
import 'components/orderSummary/orderSummary.scss';
import { getNumberOfCartItems } from 'services/cartUtils';

import { CartItem } from './components/cartItem/cartItem';
import { DiscountLineItems } from './components/discountLineItems/discountLineItems';

import template from './orderSummary.html';

export const OrderSummary = angular
    .module('checkout.components.volt.orderSummary', [
        CartItem,
        OrderSummaryCollapsed,
        OrderNotes,
        OrderSummaryToggle,
        PromoCodeForm,
        GiftCardChips,
        'ngMaterial',
        DiscountLineItems
    ]).component('voltOrderSummary', {
        template,
        bindings: {
            storeCreditInfo: '<',
            removeStoreCreditItem: '<',
            orderNotes: '<',
            onOrderNotesChanged: '<',
            onRemovePromoClicked: '<',
            onApplyPromoClicked: '<',
            promoCodeNotFound: '<',
            promoCodeExpired: '<',
            inactiveGiftCard: '<',
            giftCardNotAllowed: '<',
            giftCardAlreadyApplied: '<',
            cannotAddMoreStoreCredit: '<',
            discountCodeExistsInCart: '<',
            readOnly: '<',
            order: '<',
            returnUrl: '<',
            onCheckoutClicked: '<',
            checkoutButtonDisabled: '<',
            showCheckoutButton: '<',
            paymentMethod: '<',
            isReturnFromPaypal: '<',
            initPaypalSdkSummaryButton: '<',
            shippingAmount: '<',
            totalItems: '<',
            cartId: '<',
            cartItems: '<',
            subtotal: '<',
            taxAmount: '<',
            grandTotal: '<',
            discountAmount: '<',
            discounts: '<'
        },
        controller: class OrderSummaryCtrl {
            constructor($window, $scope, $mdMedia, $rootScope, $timeout) {
                angular.extend(this, {
                    $window,
                    $scope,
                    $mdMedia,
                    $rootScope,
                    $timeout,
                    collapsable: true
                });
            }

            $onInit() {
                this.$scope.$watch(() => this.$mdMedia('gt-sm'), (desktop) => {
                    this.collapsable = !desktop;
                    this.collapsed = !desktop;
                });

                this.unbindForcePromoInputVisible =
                    this.$rootScope.$on('OrderSummaryCtrl:ForcePromoInputVisible', () => {
                        this.collapsed = false;
                        this.showPromoInput = true;
                        this.$timeout(() => {
                            this.$window.document.querySelector('promo-code-form input').focus();
                        });
                    });
                if (this.orderNotes) {
                    this.showOrderNotes = true;
                }

                this.totalItemCount = getNumberOfCartItems(this.cartItems);
            }

            $onDestroy() {
                this.unbindForcePromoInputVisible();
            }

            goToStorefront() {
                this.$window.location.href = this.returnUrl;
            }

            onShowPromoInputClicked() {
                this.showPromoInput = true;
            }

            openSummary() {
                if (!this.collapsable) return;
                this.collapsed = !this.collapsed;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/newCheckout/components/orderSummary/orderSummary.js